import api from "./axios";
import { apiPaths } from "./paths";
import type { Category } from "@/types";

export const getCategories = () =>
  api.get<Category[]>(apiPaths.categories.list()).then((r) => r.data);
